'use strict';

var TrendChartDirective = function TrendChartDirective(Chart) {
  return {
    restrict: 'E',
    template: require('../templates/trend-chart.html'),
    controller: 'TrendChartController',
    scope: {
      screen: '@',
      mode: '@',
      type: '@',
      label: '@',
      isVisible: '='
    },
    link: function link(scope, element) {
      var chartElement = element.find('.chart-container');
      var chart = new Chart(chartElement, scope.chartFormatters);
      scope.renderChartDataPresent = function (data) {
        chart.render(data);
      };
    }
  };
};
TrendChartDirective.$inject = ['TrendChart'];
module.exports = TrendChartDirective;